import { useSearchParams } from 'react-router-dom';

export const tabValues = ['calendar', 'collections', 'achievements'] as const;
export const defaultTabValue = tabValues[0];

export const useActiveTab = (): (typeof tabValues)[number] => {
	const [searchParams] = useSearchParams();

	if (
		tabValues.includes(
			searchParams.get('tab') as (typeof tabValues)[number]
		)
	)
		return searchParams.get('tab') as (typeof tabValues)[number];
	return tabValues[0];
};
